export const PARTNER_COOKIE = 'bw-partner';

export const PARTNERS = {
  'first-choice': {
    name: 'First Choice',
    url: 'https://www.firstchoice.co.uk/'
  },
  'co-op holidays': {
    name: 'Co-op Holidays',
    url: 'https://www.cooptravel.co.uk/'
  },
  'guardian-holidays': {
    name: 'The Guardian Holidays',
    url: 'https://holidays.theguardian.com/'
  }
} as const;

export const PARTNER_ALIASES = {
  first_choice: 'first-choice',
  firstchoice: 'first-choice',
  'coop-holidays': 'co-op holidays',
  coop_holidays: 'co-op holidays',
  'guardian-holidays': 'guardian-holidays',
  the_guardian_holidays: 'guardian-holidays'
} as const;

export type PartnerCookie = keyof typeof PARTNERS | undefined;

export const isValidPartner = (partner: string) => {
  return Object.keys(PARTNERS).includes(partner) || partner in PARTNER_ALIASES;
};

export const convertToValidPartner = (partner: string | undefined): PartnerCookie | undefined => {
  if (!partner) return undefined;
  partner = partner.trim().toLowerCase();

  if (partner in PARTNERS) return partner as PartnerCookie;
  if (partner in PARTNER_ALIASES) return PARTNER_ALIASES[partner] as PartnerCookie;

  return undefined;
};
